<template>
  <div>
    <div class="card" style="max-width: 100%">
      <div class="card-header">
        <b>Listar Roles</b>
        <a
          href="http://www.vigilacontigo.com/manuales/manual_usuarios.pdf"
          target="_blank"
          class="float-right"
          v-b-tooltip.hover
          title="Ver Manual"
          ><img
            src="http://www.vigilacontigo.com/manuales/pdf.png"
            style="width: 32px"
        /></a>
      </div>
      <div class="card-body text-dark">
        <b-modal id="crear" size="lg" title="Crear Rol" hide-footer>
          <form>
            <div class="form-group">
              <label>Nombre</label>
              <input
                type="text"
                class="form-control"
                v-model="roles.name"
                required
              />
            </div>
            <br />
            <center>
              <button
                type="submit"
                @click.prevent="saveRol"
                class="btn btn-success"
              >
                Guardar
              </button>
            </center>
          </form>
        </b-modal>

        <div class="row">
          <div class="col-sm-5">
            <b-button
              class="btn btn-add-vg"
              v-b-modal.crear
              @click="
                resetForm();
                editedIndex = -1;
              "
              ><i class="mdi mdi-plus"></i> Crear Rol</b-button
            ><br /><br />
          </div>
          <div class="col-sm-6">
            <b-form-input
              class="col-sm-12"
              v-model="filter"
              type="search"
              placeholder="Busqueda"
            ></b-form-input>
          </div>
          <div class="col-sm-1">
            <b-button
              class="btn btn-info"
              style="float: right"
              @click="getRoles"
              ><i class="mdi mdi-replay"></i></b-button
            ><br /><br />
          </div>
        </div>

        <div class="text-center" v-if="loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <b-table
          class="table responsive table-bordered"
          stacked="md"
          show-empty
          small
          :per-page="perPage"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template #cell(actions)="row">
            <b-modal :id="row.item.id" size="lg" :title="title" hide-footer>
              <form>
                <div class="form-group">
                  <label>Nombre</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="roles.name"
                    :disabled="disabled"
                  />
                </div>
                <br />
                <center>
                  <button
                    type="submit"
                    @click.prevent="saveRol"
                    class="btn btn-success"
                    :disabled="disabled"
                  >
                    Guardar
                  </button>
                </center>
              </form>
            </b-modal>
            <b-button
              class="btn btn-info"
              @click="
                $bvModal.show(row.item.id);
                showModal(row.item, true, 'Ver Rol');
              "
              v-b-tooltip.hover
              title="Ver Rol"
              ><i class="mdi mdi-eye"></i></b-button
            >&nbsp;
            <b-button
              class="btn btn-warning"
              @click="
                $bvModal.show(row.item.id);
                showModal(row.item, false, 'Editar Rol');
                editedIndex = 1;
              "
              v-b-tooltip.hover
              title="Editar Rol"
              ><i class="mdi mdi-pencil text-white"></i></b-button
            >&nbsp;
            <b-button
              class="btn btn-danger"
              @click="deleteRol(row.item)"
              v-b-tooltip.hover
              title="Eliminar Rol"
              ><i class="mdi mdi-delete"></i
            ></b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { headers } from "./../../../api/headers";
import { configApi } from "./../../../api/configApi";
export default {
  name: "listado_roles",
  data: () => ({
    title: "",
    perPage: 5,
    filter: null,
    currentPage: 1,
    loading: true,
    disabled: false,
    viewModal: false,
    items: [],
    columns: [
      {
        name: "id",
        th: "ID",
      },
      {
        name: "name",
        th: "Nombre",
      },
    ],
    fields: [
      { key: "id", label: "ID", sortable: true },
      { key: "name", label: "Nombre", sortable: true, class: "text-center" },
      { key: "actions", label: "Acciones", class: "text-center" },
    ],
    editedIndex: -1,
    roles: {
      id: "",
      name: "",
    },
  }),
  computed: {
    rows() {
      return this.items.length;
    },
  },
  created() {
    this.getRoles();
  },

  methods: {
    showModal(datos, disabled, title) {
      this.disabled = disabled;
      this.title = title;
      this.roles.id = datos.id;
      this.roles.name = datos.name;
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    async getRoles() {
      return await this.axios
        .get(configApi + "usuarios/roles", { headers })
        .then((response) => {
          this.items = response.data.data;
          this.loading = false;
        });
    },
    async saveRol() {
      if (this.editedIndex > -1) {
        return await this.axios
          .put(configApi + "usuarios/roles/" + this.roles.id, this.roles, {
            headers,
          })
          .then((response) => {
            this.$bvModal.hide(this.roles.id);
            this.resetForm();
            this.getRoles();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      } else {
        return await this.axios
          .post(configApi + "usuarios/roles", this.roles, { headers })
          .then((response) => {
            this.$bvModal.hide("crear");
            this.resetForm();
            this.getRoles();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      }
    },
    async deleteRol(data) {
      let objAlert = {
        titleAlert: "¿Desea eliminar el Rol?",
        url: configApi + "usuarios/roles/" + data.id, // url delete
        headers: { headers },
        messageError: "El Rol no fue Eliminado",
      };

      this.$Fun.alertaConfirmarEliminarAccion(objAlert, (e) => {
        if (e) {
          this.getRoles();
        }
      });
    },
    resetForm() {
      (this.roles.id = ""), (this.roles.name = "");
    },
  },
};
</script>
<style>
.mostrar {
  display: list-item;
  opacity: 1;
  background: rgba(0, 0, 0, 0.425);
}
</style>
